module.exports = __webpack_public_path__ + "static/media/e-lean-gray-scale.2675db2c.png";